/* eslint-disable @typescript-eslint/naming-convention */

/** Limit server call and use the data from the UI cache after the limit is reached
 * TODO: Remove UI cache when Redis cache is implemented on the server side
*/
export const COMPONENT_DEFINITION_GET_FROM_SERVER_LIMIT = 1;
